import React from 'react';

import {Button} from '@kit';

import css from './sheet.module.css';

export type FilterChip<T extends string> = {
	value: T;
	label: string;
	count?: number;
};

type Props<T extends string> = {
	items: FilterChip<T>[];
	value: T;
	onChange(value: T): void;
	label: string;
};

export function FilterChips<T extends string>({items, value, onChange, label}: Props<T>) {
	return (
		<div className={css.filterChips} role="tablist" aria-label={label}>
			{items.map((item) => (
				<Button
					key={item.value}
					size="small"
					shape="circular"
					appearance={item.value === value ? 'primary' : 'secondary'}
					role="tab"
					aria-selected={item.value === value}
					onClick={() => onChange(item.value)}
				>
					{item.label}
					{item.count != null && <span className={css.chipCount}>{item.count}</span>}
				</Button>
			))}
		</div>
	);
}
